module.exports = __webpack_public_path__ + "img/classify_9.1bfe7098.png";